'use strict';

exports.__esModule = true;

var _apiClient = require('../../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PREFIX = '/quiqee/pay_structure';

var API = {
  FEE_SUPPLEMENTS: PREFIX + '/fee_supplements',
  ZONE_GROUPS: PREFIX + '/zone_groups',
  TIME_SURGES: PREFIX + '/time_surges',
  JOB_FEE_STAMP: PREFIX + '/job_fee_stamp'

  /**
   * Wrapper for `/quiqee/pay_structure` API endpoint
   */

};var payStructure = {
  getFeeSupplements: getFeeSupplements,
  getZoneGroups: getZoneGroups,
  getTimeSurges: getTimeSurges,
  getJobFeeStamp: getJobFeeStamp
};

exports.default = payStructure;

/**
 * Get current fee supplements for quiqee
 * @see https://api.qa.quiq.ly/api_docs#!/quiqee/GET_quiqee_pay_structure_fee_supplements_format
 * @returns {promise} containing array of fee suplements
 */

function getFeeSupplements() {
  return _apiClient2.default.get({ route: API.FEE_SUPPLEMENTS });
}

/**
 * Get zone groups for current quiqee
 * @see https://api.qa.quiq.ly/api_docs#!/quiqee/GET_quiqee_pay_structure_zone_groups_format
 * @returns {promise} containing array of zones
 */
function getZoneGroups() {
  return _apiClient2.default.get({ route: API.ZONE_GROUPS });
}

/**
 * Get time surges for current quiqee
 * @see https://api.qa.quiq.ly/api_docs#!/quiqee/GET_quiqee_pay_structure_time_surges_format
 * @returns {promise} containing array of time surges
 */
function getTimeSurges() {
  return _apiClient2.default.get({ route: API.TIME_SURGES });
}

/**
 * Get job fee stamps for current quiqee
 * @see https://api.qa.quiq.ly/api_docs#!/quiqee/GET_quiqee_pay_structure_job_fee_stamp_format
 * @returns {promise} containing an object of job fee stamps
 */
function getJobFeeStamp() {
  return _apiClient2.default.get({ route: API.JOB_FEE_STAMP });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/quiqee/pay-structure/pay-structure.js
// module id = 1180
// module chunks = 0